import { render, staticRenderFns } from "./IPACache.vue?vue&type=template&id=452bfc98&scoped=true&"
import script from "./IPACache.vue?vue&type=script&lang=js&"
export * from "./IPACache.vue?vue&type=script&lang=js&"
import style0 from "./IPACache.vue?vue&type=style&index=0&id=452bfc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bfc98",
  null
  
)

export default component.exports